<template>
  <div
    class="iframe-container swiper-container-horizontal swiper-3d-container"
    :style="getStyle"
    @mouseenter="iframeShadowStatus = true"
    @mouseleave="iframeShadowStatus = false"
  >
    <iframe
      class="swiper-3d-container"
      :id="swiperKey"
      :src="iframeSrc"
      frameborder="0"
      :scrolling="iframeScrollStatus == true ? 'auto' : 'no'"
      ref="swiper"
      :key="iframeSrc"
    ></iframe>
    <div class="iframe-shadow" v-if="!isActive && !this.isBigScreenPreview()"></div>
    <div
      ref="pagination"
      v-show="showPagination"
      class="swiper-pagination"
      :class="{ 'swiper-pagination-progressbar': paginationType === 'progressbar' }"
      slot="pagination"
    >
      <!-- 圆点类型 -->
      <template v-if="paginationType === 'bullets'">
        <span
          v-for="(val, index) in swiperLength"
          :class="index === swiperIndex ? 'swiper-pagination-bullet-active' : ''"
          class="swiper-pagination-bullet"
          @click="changePageIndex(index)"
        ></span>
      </template>
      <!-- 分数类型 -->
      <template v-if="paginationType === 'fraction'">
        <span class="swiper-pagination-current">{{ swiperIndex + 1 }}</span> /
        <span class="swiper-pagination-total">{{ swiperLength }}</span>
      </template>
      <!-- 进度条 -->
      <template v-if="paginationType === 'progressbar'">
        <span
          class="swiper-pagination-progressbar-fill"
          :style="{
            transform: `translate3d(0px, 0px, 0px) scaleX(${(swiperIndex + 1) / swiperLength}) scaleY(1)`,
            transitionDuration: '600ms'
          }"
        ></span>
      </template>
      <!-- 矩形 -->
      <template v-if="paginationType === 'rectangle'">
        <span
          v-for="(val, index) in swiperLength"
          :class="index === swiperIndex ? 'swiper-pagination-bullet-active' : ''"
          class="swiper-pagination-bullet"
          tabindex="0"
          role="button"
          aria-label="Go to slide 3"
          @click="changePageIndex(index)"
        ></span>
      </template>
    </div>
  </div>
</template>

<script>
import eventMixin from "utils/event/eventMixin.js"
import { _debounce, updateSubPageNameHandle } from "utils"
import { v1 } from "uuid"
export default {
  mixins: [eventMixin],
  name: "cxSwiper3D",
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    },
    isGridItem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isReady: false,
      myplayer: null,
      isError: false,
      iframeShadowStatus: false,
      swiperIndex: 0,
      showMask: true
    }
  },
  beforeMount() {
    window.addEventListener("message", this.swiperHandle, false)
    this.deBounceUpdater = _debounce(newConfig => {
      this.updateSwiper("PortalUpdate", newConfig)
    }, 200)
  },
  mounted() {
    this.initPagination()
  },
  beforeDestroy() {},
  destroyed() {
    window.removeEventListener("message", this.swiperHandle)
  },
  computed: {
    activeID() {
      return this.$store.state.states.activeID
    },
    ids() {
      return this.myid
    },
    isActive() {
      return this.activeID?.rect_id === this.myid.rect_id
    },
    iframeSrc() {
      // 测试地址
      //http://vjs.zencdn.net/v/oceans.mp4
      return this.options.iframeUrl
        ? this.options.iframeUrl + `&componentID=${this.swiperKey}&updateFinishToast=true`
        : "https://www.chaoxing.com"
    },
    bgStyle() {
      let containerBg = {
        backgroundImage: ""
      }
      let curBackground = this.options.background
      if (
        !curBackground ||
        !Array.isArray(curBackground) ||
        (Array.isArray(curBackground) && curBackground.length === 0)
      ) {
        curBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.options.hasOwnProperty("allBgColorIsThemeColor")
              ? this.options.allBgColorIsThemeColor
              : false,
            color: this.options.allBgColor
          }
        ]
      }
      curBackground.forEach(bg => {
        switch (bg.type) {
          case "img":
            let dot1 = containerBg.backgroundImage.length > 0 ? "," : ""
            containerBg.backgroundImage += `${dot1}url(${bg.imgUrl})`
            containerBg.backgroundSize = containerBg.backgroundSize
              ? `${containerBg.backgroundSize},${bg.clipSize}`
              : `${bg.clipSize}`
            containerBg.backgroundPosition = containerBg.backgroundPosition
              ? `${containerBg.backgroundPosition},${bg.alignType}`
              : `${bg.alignType}`
            containerBg.backgroundRepeat = containerBg.backgroundRepeat
              ? `${containerBg.backgroundRepeat},${bg.repeatType}`
              : `${bg.repeatType}`
            break
          case "color":
            containerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = containerBg.backgroundImage.length > 0 ? "," : ""
              containerBg.backgroundImage += dot + this.$parseColor(bg)
              containerBg.backgroundSize = containerBg.backgroundSize ? `${containerBg.backgroundSize},auto` : `auto`
              containerBg.backgroundPosition = containerBg.backgroundPosition
                ? `${containerBg.backgroundPosition},center`
                : `center`
              containerBg.backgroundRepeat = containerBg.backgroundRepeat
                ? `${containerBg.backgroundRepeat},no-repeat`
                : `no-repeat`
            }
            break
          default:
        }
      })
      return containerBg
    },
    boxShadowStyle() {
      let tmpStyle = ""
      let _this = this
      if (Array.isArray(this.options.boxShadowH)) {
        this.options.boxShadowH.forEach((item, index) => {
          if (index > 0) {
            tmpStyle += ","
          }
          tmpStyle += `${_this.options.boxShadowH[index]}px ${_this.options.boxShadowV[index]}px ${_this.options.boxShadowBlur[index]}px ${_this.options.boxShadowSpread[index]}px ${_this.$parseColor(_this.options.boxShadowColor[index])}`
        })
      } else {
        tmpStyle += `${this.options.boxShadowH}px ${this.options.boxShadowV}px ${this.options.boxShadowBlur}px ${this.options.boxShadowSpread}px ${this.$parseColor(this.options.boxShadowColor)}`
      }
      return tmpStyle
    },
    getPaddingStyle() {
      let padding = `${this.options.padding}px`
      if (this.options.paddingTypeFlag === 2) {
        padding = ` ${this.options.paddingTop}px  ${this.options.paddingRight}px  0px  ${this.options.paddingLeft}px`
      }
      return padding
    },
    getStyle() {
      let borderW = ""
      if (Array.isArray(this.options.borderWidth)) {
        this.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
      } else {
        borderW += ` ${this.options.borderWidth}px`
      }
      let res = {
        ...this.bgStyle,
        // transform: "rotate(" + this.options.rotate + "deg)",
        // "--swiper-bullets-primary-color": this.options.bulletsPrimaryIsTheme
        //   ? this.themeColor
        //   : this.options.pagination.bulletsPrimaryColor && this.options.pagination.bulletsPrimaryColor.color
        //   ? this.options.pagination.bulletsPrimaryColor.color
        //   : this.options.pagination.bulletsPrimaryColor,
        "--swiper-bullets-primary-color": this.$parseColor(this.options.pagination.bulletsPrimaryColor, {
          isThemeColor: this.options.bulletsPrimaryIsTheme
        }),
        // "--swiper-bullets-active-Color": this.options.bulletsActiveIsTheme
        //   ? this.themeColor
        //   : this.options.pagination.bulletsActiveColor && this.options.pagination.bulletsActiveColor.color
        //   ? this.options.pagination.bulletsActiveColor.color
        //   : this.options.pagination.bulletsActiveColor,
        "--swiper-bullets-active-Color": this.$parseColor(this.options.pagination.bulletsActiveColor, {
          isThemeColor: this.options.bulletsActiveIsTheme
        }),
        "--swiper-button-size": this.options.buttonIconSize + "px",
        // "--swiper-button-color":
        //   this.options.buttonIconColor && this.options.buttonIconColor.color
        //     ? this.options.buttonIconColor.color
        //     : this.options.buttonIconColor,
        "--swiper-button-color": this.$parseColor(this.options.buttonIconColor),
        "--swiper-button-box-padding": this.options.buttonIconPadding + "px",
        "--swiper-button-box-left-x": this.options.buttonIconCustomTop
          ? this.options.leftButtonIconXType === "%"
            ? this.options.leftButtonIconX + "%"
            : this.options.leftButtonIconX + "px"
          : this.options.buttonIconPadding + "px",
        "--swiper-button-box-left-y": this.options.buttonIconCustomTop ? this.options.leftButtonIconY + "px" : "50%",
        "--swiper-button-box-right-x": this.options.buttonIconCustomTop
          ? this.options.rightButtonIconXType === "%"
            ? this.options.rightButtonIconX + "%"
            : this.options.rightButtonIconX + "px"
          : this.options.buttonIconPadding + "px",
        "--swiper-button-box-right-y": this.options.buttonIconCustomTop ? this.options.rightButtonIconY + "px" : "50%",
        // "--swiper-button-box-progressbarBackground": this.options.progressbarIsTheme
        //   ? this.themeColor
        //   : this.options.progressbarBackground && this.options.progressbarBackground.color
        //   ? this.options.progressbarBackground.color
        //   : this.options.progressbarBackground,
        "--swiper-button-box-progressbarBackground": this.$parseColor(this.options.progressbarBackground, {
          isThemeColor: this.options.progressbarIsTheme
        }),
        "--swiper-button-box-buttonIconTop": this.options.buttonIconCustomTop
          ? this.options.buttonIconTop + "px"
          : "50%",
        "--swiper-button-box-buttonIconMarginTop": this.options.buttonIconCustomTop
          ? "0px"
          : "-" + this.options.buttonIconBackgroundHeight / 2 + "px",
        "--swiper-bullets-bulletsSize": this.options.bulletsMargin + "px",
        "--swiper-bullets-bulletsWidth":
          this.options.pagination.type === "rectangle"
            ? this.options.rectangleWidth + "px"
            : this.options.bulletsMargin + "px",
        "--swiper-bullets-bulletsHeight":
          this.options.pagination.type === "rectangle"
            ? this.options.rectangleHeight + "px"
            : this.options.bulletsMargin + "px",
        "--swiper-bullets-activeWidth":
          this.options.pagination.type === "rectangle"
            ? this.options.rectangleActiveWidth + "px"
            : this.options.bulletsMargin + "px",
        "--swiper-bullets-activeHeight":
          this.options.pagination.type === "rectangle"
            ? this.options.rectangleActiveHeight + "px"
            : this.options.bulletsMargin + "px",
        "--swiper-bullets-bulletsRadius":
          this.options.pagination.type === "rectangle" ? this.options.bulletsRadius + "px" : "100%",
        "--swiper-bullets-bulletsMargin": `0 ${this.options.bulletsSize / 2}px`,
        "--swiper-button-box-width": this.options.buttonIconBackgroundWidth + "px",
        "--swiper-button-box-height": this.options.buttonIconBackgroundHeight + "px",
        opacity: this.options.opacity / 100,
        "box-shadow": this.boxShadowStyle,
        "border-top-left-radius": this.options.borderTopLeftRadius + "px",
        "border-top-right-radius": this.options.borderTopRightRadius + "px",
        "border-bottom-right-radius": this.options.borderBottomRightRadius + "px",
        "border-bottom-left-radius": this.options.borderBottomLeftRadius + "px",
        "border-style": this.options.borderStyle,
        // "border-color":
        //   this.options.borderColor && this.options.borderColor.color
        //     ? this.options.borderColor.color
        //     : this.options.borderColor,
        "--border-color": this.$parseColor(this.options.borderColor),
        "border-width": borderW,
        "--swiper-padding-bottom": this.options.paddingBottom + "px",
        padding: this.getPaddingStyle,
        "--swiper-button-box-shadow": this.buttonBoxShadowStyle,
        // "--swiper-pagination-primary-color": this.options.fractionIsThemeColor
        //   ? this.themeColor
        //   : this.options.fractionColor && this.options.fractionColor.color
        //   ? this.options.fractionColor.color
        //   : this.options.fractionColor
        "--swiper-pagination-primary-color": this.$parseColor(this.options.fractionColor, {
          isThemeColor: this.options.fractionIsThemeColor
        }),
      }
      return res
    },
    iframeScrollStatus() {
      return this.options.iframeScrollStatus
    },
    noCacheComponent() {
      return this.options && this.options.noCacheComponent ? this.options.noCacheComponent : false
    },
    duration() {
      return this.options.autoPlayDelay || 3
    },
    swiperConfig() {
      return JSON.stringify({
        loop: this.options.loop ?? true,
        autoPlay: this.options.autoPlay ?? true,
        dataList: this.swiperDataList
      })
    },
    swiperDataList() {
      const list = (this.options.dataList || []).filter(({ type, imgUrl, objectId }) => {
        if (type === "img") return this.getImageObjectId(imgUrl)
        if (type === "video") return objectId
      })
      return list.map(item => {
        const { type, objectId, imgUrl, label, autoplay, loopPlay, linkUrl, openBlank } = item
        return {
          id:
            type === "img"
              ? this.getImageObjectId(imgUrl)
              : objectId,
          type: type === "img" ? 0 : 1,
          duration: parseFloat(this.duration),
          name: label,
          url: linkUrl,
          url_page: openBlank,
          loop: loopPlay,
          autoPlay: autoplay
        }
      })
    },
    swiperKey: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "swiperKey", "swiperKey", v1())
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "swiperKey", false, null, this.getRectId)
      }
    },
    swiperCover: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "swiperCover", "swiperCover", '')
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "swiperCover", false, null, this.getRectId)
      }
    },
    swiperLength() {
      if (this.swiperDataList.length < 3) {
        return this.swiperDataList.length
      }
      return this.swiperDataList.length + 1
    },
    paginationType() {
      return this.options.pagination.type
    },
    showPagination() {
      return this.options.showPagination
    }
  },
  watch: {
    isAcitve(value) {
      setTimeout(() => {
        this.showMask = !value
      }, 1000)

    },
    "options.paginationPosition": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.paginationLeft": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.paginationRight": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.paginationTop": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.paginationBottom": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.showPagination"(newVal, oldVal) {
      if (newVal) {
        this.initPaginationPosition()
      }
    },
    "options.pagination": {
      deep: true,
      handler(newVal, oldVal) {
        this.changeBulletsColor()
        this.initPaginationPosition()
      }
    },
    "options.fractionColor": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.progressbarWidth": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    "options.progressbarHeight": {
      deep: true,
      handler(neaval, oldval) {
        this.initPaginationPosition()
      }
    },
    swiperConfig(newConfig) {
      this.deBounceUpdater(newConfig)
      // this.updateSwiper("PortalUpdate", newConfig)
    }
  },
  methods: {
    getImageObjectId(imgUrl) {
      if (!imgUrl) return ''
      let objectId = ''
      objectId = imgUrl.match(/p\.ananas\.chaoxing.com\/star3\/(?:.*?)?\/(.*)?\.[jpeg|png|jpg|gif]/)?.[1]
      if (objectId) return objectId
      objectId = imgUrl.match(/p\.cldisk\.com\/star3\/(?:.*?)?\/(.*)?\.[jpeg|png|jpg|gif]/)?.[1]
      if (objectId) return objectId
      return ''
    },
    changePageIndex(index) {
      this.$refs.swiper.contentWindow.postMessage(
        {
          type: "PortalToggleScene",
          params: {
            index: index,
            componentID: this.swiperKey
          }
        },
        "*"
      )
    },
    changeBulletsColor: _debounce(function () {
      requestAnimationFrame(() => {
        let classList = this.$el.getElementsByClassName("swiper-pagination-bullet")
        if (classList.length === 0) {
          //dom还没出来 递归一下
          this.changeBulletsColor()
        } else {
          const primaryColor = this.options.bulletsPrimaryIsTheme
            ? this.themeColor
            : this.options.pagination.bulletsPrimaryColor && this.options.pagination.bulletsPrimaryColor.color
            ? this.options.pagination.bulletsPrimaryColor.color
            : this.options.pagination.bulletsPrimaryColor
          const activeColor = this.options.bulletsActiveIsTheme
            ? this.themeColor
            : this.options.pagination.bulletsActiveColor && this.options.pagination.bulletsActiveColor.color
            ? this.options.pagination.bulletsActiveColor.color
            : this.options.pagination.bulletsActiveColor
          // dom有了 开始处理逻辑
          Array.from(classList).forEach((span, index) => {
            if (span.className.includes("swiper-pagination-bullet-active")) {
              this.paginationActiveIndex = index
              // span.style["background-color"] = activeColor
            } else {
              // span.style["background-color"] = primaryColor
            }
          })
        }
      })
    }, 100),
    initPagination() {
      if (!this.showPagination) return
      // pagination
      const position = this.options.paginationPosition
      const type = this.options.pagination.type
      const el = this.$refs.pagination
      if (!el) this.initPaginationPosition()
      if (!el) return
      if (el && !el.classList) this.initPaginationPosition()
      el?.classList.remove("swiper-pagination-bullets")
      el?.classList.remove("swiper-pagination-fraction")
      switch (position) {
        case "left":
          initStyle.call(this, el)
          if (this.options.direction === "horizontal" || type !== "progressbar") {
            el.style.transform = "rotate(90deg)"
          }
          if (type !== "progressbar") {
            el.style.top = "50%"
          }
          el.style.right = ""
          el.style.left = this.options.paginationLeft + "px"
          break
        case "right":
          initStyle.call(this, el)
          if (this.options.direction === "horizontal" || type !== "progressbar") {
            el.style.transform = "rotate(90deg)"
          }
          if (type !== "progressbar") {
            el.style.top = "50%"
          }
          el.style.left = "auto"
          el.style.right = this.options.paginationRight + "px"
          break
        case "top":
          initStyle.call(this, el)
          if (type !== "progressbar") {
            el.style.width = "100%"
          }
          el.style.top = this.options.paginationTop + "px"
          break
        case "bottom":
          initStyle.call(this, el)
          if (type !== "progressbar") {
            el.style.width = "100%"
          }
          el.style.top = "auto"
          el.style.bottom = this.options.paginationBottom + "px"
          break
        case "leftTop":
          initStyle.call(this, el)
          el.style.top = this.options.paginationTop + "px"
          el.style.left = this.options.paginationLeft + "px"
          el.style.right = ""
          el.style.bottom = ""
          break
        case "rightTop":
          initStyle.call(this, el)
          el.style.top = this.options.paginationTop + "px"
          el.style.right = this.options.paginationRight + "px"
          el.style.left = "auto"
          el.style.bottom = "auto"
          break
        case "leftBottom":
          initStyle.call(this, el)
          el.style.top = "auto"
          el.style.right = "auto"
          el.style.left = this.options.paginationLeft + "px"
          el.style.bottom = this.options.paginationBottom + "px"
          break
        case "rightBottom":
          initStyle.call(this, el)
          el.style.top = "auto"
          el.style.right = this.options.paginationRight + "px"
          el.style.left = "auto"
          el.style.bottom = this.options.paginationBottom + "px"
          break
        default:
          break
      }
      function initStyle(el) {
        if (!el) return
        if (el.style) el.removeAttribute("style")
        if (type === "fraction") {
          const {
            fractionFontFamily,
            fractionFontSize,
            fractionFontWeight,
            fractionLineHeight,
            fractionLineHeightType,
            fractionFontStyle,
            fractionTextDecoration,
            fractionLetterSpacing,
            fractionWritingMode,
            fractionTextAlign,
            fractionVerticalAlign
          } = this.options.pagination
          const style = el.style
          // style.color = this.options.fractionIsThemeColor
          //   ? this.themeColor
          //   : this.options.fractionColor && this.options.fractionColor.color
          //   ? this.options.fractionColor.color
          //   : "white"
          style.color = this.$parseColor(this.options.fractionColor, {
            isThemeColor: this.options.fractionIsThemeColor
          }) || 'white'
          style.fontFamily = fractionFontFamily
          style.fontSize = fractionFontSize + "px"
          style.fontWeight = fractionFontWeight
          style.fontStyle = fractionFontStyle
          style.textDecoration = fractionTextDecoration
          style.height =
            fractionLineHeightType === "%"
              ? (fractionLineHeight / 100) * fractionFontSize + "px"
              : fractionLineHeight + "px"
          style.letterSpacing = fractionLetterSpacing + "px"
          if (fractionWritingMode === "vertical-lr") {
            style.display = "flex"
            style.flexDirection = "column"
            switch (fractionTextAlign) {
              case "left":
              case "justify":
                style.justifyContent = "start"
                break
              case "center":
                style.justifyContent = "center"
                break
              case "right":
                style.justifyContent = "end"
            }
          } else {
            style.display = "flex"
            style.justifyContent = "center"
            switch (fractionVerticalAlign) {
              case "top":
                style.alignItems = "start"
                break
              case "center":
                style.alignItems = "center"
                break
              case "bottom":
                style.alignItems = "end"
            }
            switch (fractionTextAlign) {
              case "left":
              case "justify":
                style.justifyContent = "start"
                break
              case "center":
                style.justifyContent = "center"
                break
              case "right":
                style.justifyContent = "end"
            }
          }
        }
        if (type === "progressbar") {
          if (this.options.direction === "horizontal") {
            el.style.width = this.options.progressbarWidth + "%"
            el.style.height = this.options.progressbarHeight + "px"
          } else {
            el.style.width = this.options.progressbarHeight + "px"
            el.style.height = this.options.progressbarWidth + "%"
          }
          // el.style.background = this.options.bulletsPrimaryIsTheme
          //   ? this.themeColor
          //   : this.options.pagination.bulletsPrimaryColor && this.options.pagination.bulletsPrimaryColor.color
          //   ? this.options.pagination.bulletsPrimaryColor.color
          //   : this.options.pagination.bulletsPrimaryColor
          el.style.background = this.$parseColor(this.options.pagination.bulletsPrimaryColor, {
            isThemeColor: this.options.bulletsPrimaryIsTheme
          })
        }
      }
    },
    initPaginationPosition: _debounce(function() {
      this.initPagination()
    }, 100),
    swiperHandle(event) {
      const { data } = event
      if (data.params?.componentID !== this.swiperKey) return
      if (data.type === "iframeLoaded") {
        this.isReady = true
        this.updateSwiper("PortalInit")
      } else if (data.type === "paginationUpdate") {
        console.log("当前展板", data.params.index)
        this.swiperIndex = data.params.index
      } else if (data.type === 'toShotScreen') {
        this.swiperCover = data?.params?.coverId
      }
    },
    updateSwiper(type) {
      this.$refs.swiper.contentWindow.postMessage(
        {
          type,
          params: { componentID: this.swiperKey, ...JSON.parse(this.swiperConfig) }
        },
        "*"
      )
    }
  }
}
</script>

<style scoped>
.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  transform: scale(0);
  transform-origin: left top;
}
::v-deep .swiper-pagination-progressbar-fill {
  background: var(--swiper-button-box-progressbarBackground) !important;
}

::v-deep .swiper-pagination-bullet {
  margin: var(--swiper-bullets-bulletsMargin) !important;
  width: var(--swiper-bullets-bulletsWidth);
  height: var(--swiper-bullets-bulletsHeight);
  border-radius: var(--swiper-bullets-bulletsRadius);
  background: var(--swiper-bullets-primary-color);
  opacity: 1;
  display: inline-block !important;
  cursor: pointer;
}

::v-deep .swiper-pagination-bullet-active {
  background: var(--swiper-bullets-active-Color) !important;
  width: var(--swiper-bullets-activeWidth);
  height: var(--swiper-bullets-activeHeight);
}

.overflowHidMultiLines {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.iframe-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.iframe-container > iframe {
  width: 100%;
  height: 100%;
}
.iframe-container > iframe::-webkit-scrollbar {
  display: none;
}
.iframe-shadow {
  position: absolute;
  top: 0;
  left: 0;
  right: 20px;
  bottom: 20px;
  z-index: 2;
}
</style>
